import isNil from 'lodash/isNil'
import { User } from '../../types/user'

declare global {
  interface Window {
    analytics: any
  }
}

export const identifySegmentUser = (user: User) => {
  if (process.env.VUE_APP_ENV !== 'live') return
  if (!window.analytics) return void console.error('Segment script not loaded')

  window.analytics.identify(user._id, {
    firstName: user.first_name,
    lastName: user.last_name,
    fullName: `${user.first_name || ''} ${user.last_name || user.name}`,
    company: user.company?._id,
    companyName: user.company?.name,
    companyStatus: user.company?.status,
    email: user.email,
    userGroups: user.groups?.map(group => group.name).join(),
    environment: getEnvironment(),
    plan: user?.company?.tier
  })

  const userData = JSON.parse(window.localStorage.getItem('ajs_user_traits') || '{}')
  window.analytics.group(user.company?._id, { name: user.company?.name, tier: user.company?.tier, ...userData })
}

const getEnvironment = (): string => {
  if (window.location.host.includes('backboneapp.cloud')) return 'QA'
  if (window.location.host.includes('backboneapp.co')) return 'Production'
  return 'Unknown'
}
